module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "cd-todoTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "type": "selection",
      "width": "55",
      "align": "center"
    }
  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "order_id_sn",
      "label": "ID",
      "width": "240",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHomePageSub) ? _c('el-table-column', {
    attrs: {
      "prop": "product_type",
      "label": "业务种类",
      "width": "120"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customer",
      "label": "客户姓名",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_name",
      "label": "产品",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settle_type",
      "label": "结清类型",
      "align": "center",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.settle_type == 1 ? '正常结清' : scope.row.settle_type == 2 ? '拖车结清' : scope.row.settle_type == 3 ? '卖车结清' : '特殊结清') + "\n                     ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_settle",
      "label": "结清金额",
      "align": "center"
    }
  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
    attrs: {
      "prop": "depart_name",
      "label": "门店",
      "align": "right"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_name",
      "label": "申请人",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "label": "业务员",
      "align": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active_time",
      "label": "最后处理时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(0 == scope.row.staff_id) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function (e) {
              return _vm.rowActionHandle(e, 'showChoice', scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.node_name))]) : _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function (e) {
              return _vm.rowActionHandle(e, 'goto', scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.node_name))]), _vm._v(" "), (2 == scope.row.last_transition_type) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function (e) {
              return _vm.rowActionHandle(e, 'showMsg', scope.row)
            }
          }
        }, [_vm._v("退回原因")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-6 text-right"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "total": _vm.totalRow,
      "layout": "total, prev, pager, next, sizes, jumper"
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.pageChangeHandle
    }
  })], 1)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.backMsgDialog.title,
      "visible": _vm.backMsgDialog.visible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.backMsgDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    ref: "backMsgForm"
  }, [_c('el-form-item', {
    attrs: {
      "label": "退回原因",
      "prop": "last_msg",
      "error": _vm.error.last_msg
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "disabled": ""
    },
    model: {
      value: (_vm.backMsgDialog.last_msg),
      callback: function($$v) {
        _vm.$set(_vm.backMsgDialog, "last_msg", $$v)
      },
      expression: "backMsgDialog.last_msg"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.backMsgDialog.visible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.choiceDialog.title,
      "visible": _vm.choiceDialog.visible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.choiceDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    ref: "choiceForm"
  }, [_c('el-form-item', {
    attrs: {
      "label": "分配给",
      "prop": "staff_id",
      "error": _vm.error.staff_id
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "required": ""
    },
    model: {
      value: (_vm.choiceDialog.staff_id),
      callback: function($$v) {
        _vm.$set(_vm.choiceDialog, "staff_id", $$v)
      },
      expression: "choiceDialog.staff_id"
    }
  }, _vm._l((_vm.staffChoiceList), function(item) {
    return _c('el-option', {
      key: item.staff_id,
      attrs: {
        "label": item.name,
        "value": item.staff_id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.choiceDialog.visible = false
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function (e) {
        return _vm.pageActionHandle(e, 'choiceForm', _vm.choiceDialog)
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('popupWin', {
    attrs: {
      "visible": _vm.showPopupWin,
      "info": _vm.popupWinInfo
    },
    on: {
      "closed": function($event) {
        _vm.showPopupWin = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8fca0e88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/part/car/task/settleOrder.vue
// module id = 1291
// module chunks = 105